import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { FormItemLayout } from 'client/ui/form/FormItem';
import { RadioInputItem } from 'client/ui/form/input/RadioInputItem';
import { FormDividerSpace } from 'client/ui/space/FormDividerSpace';
import { CitizenNationality } from 'common/schema/Citizen';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface IUserNationalityFormProps {
  layout: FormItemLayout;
}

export function UserNationalityForm(props: IUserNationalityFormProps) {
  const { layout } = props;
  const { t } = useTranslation();

  return (
    <>
      <FormDividerSpace
        title={t('user.registration.form.nationality', 'Nazionalità')}
        layout={layout}
        style={{ marginTop: 0 }}
      />
      <RadioInputItem
        name="nationality"
        label={t('user.registration.form.nationality', 'Nazionalità')}
        options={[
          {
            label: t('user.profile.nationality.italy', 'Italiana'),
            value: CitizenNationality.Italy
          },
          {
            label: (
              <Tooltip
                color="#fff"
                overlayInnerStyle={{ color: '#333' }}
                title={
                  <Trans i18nKey="user.registration.form.nationaly-eidas-help">
                    È possibile consultare{' '}
                    <a
                      target="_blank"
                      href="https://eid.gov.it/eidas-node-status"
                    >
                      l'elenco dei paesi che supportano il Login eIDAS per
                      l'Italia
                    </a>
                    .
                  </Trans>
                }
              >
                {t('user.profile.nationality.EU', 'Paesi eIDAS')}
                &nbsp;
                <QuestionCircleOutlined style={{ fontSize: '0.8em' }} />
              </Tooltip>
            ),
            value: CitizenNationality.EU
          },
          {
            label: t('user.profile.nationality.extra-EU', 'Altri Paesi'),
            value: CitizenNationality.ExtraEU
          }
        ]}
      />
    </>
  );
}
